import { createSelector } from 'reselect';

const selectTaxSettings = (state: any) => state.taxSettings;


export const selectTaxSettingsCurrentItem = createSelector([selectTaxSettings], (taxSettings) => taxSettings.current);

export const selectTaxSettingsListItems = createSelector([selectTaxSettings], (taxSettings) => taxSettings.list);

export const selectTaxSettingsItemById = (itemId: any) =>
    createSelector(selectTaxSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTaxSettingsCreatedItem = createSelector([selectTaxSettings], (taxSettings) => taxSettings.create);

export const selectTaxSettingsUpdatedItem = createSelector([selectTaxSettings], (taxSettings) => taxSettings.update);

export const selectTaxSettingsReadItem = createSelector([selectTaxSettings], (taxSettings) => taxSettings.read);

export const selectTaxSettingsDeletedItem = createSelector([selectTaxSettings], (taxSettings) => taxSettings.delete);

export const selectTaxSettingsSearchedItems = createSelector([selectTaxSettings], (taxSettings) => taxSettings.search);

export const selectTaxSettingsItemsCount = createSelector([selectTaxSettings], (taxSettings) => taxSettings.count);

export const selectTaxSettingsItemsFilter = createSelector([selectTaxSettings], (taxSettings) => taxSettings.filter);